import Vue from 'vue'
import defaultState from './state'

export default {
  setExportFields (state, payload) {
    state.exportFields = payload
  },
  setFileFormat: (state, payload) => {
    state.fileFormat = payload
  },
  setFileFormats (state, payload) {
    if (state.fileFormatsCurrentPage === 1) {
      state.fileFormats = payload
    } else {
      state.fileFormats.push(...payload)
    }
  },
  setFileFormatsFilters: (state, payload) => { state.fileFormatsFilters = payload },
  setFileFormatsLastPage: (state, payload) => { state.fileFormatsLastPage = payload },
  incrementFileFormatsCurrentPage: (state, payload) => { state.fileFormatsCurrentPage++ },
  addFileFormat: (state, payload) => {
    const { id } = payload
    const fileFormatToFindIndex = state.fileFormats.findIndex(el => el.id === id)
    if (fileFormatToFindIndex !== -1) {
      state.fileFormats.splice(fileFormatToFindIndex, 1, payload)
    } else {
      state.fileFormats.push(payload)
    }
  },
  deleteFileFormat: (state, id) => {
    const fileFormatToFindIndex = state.fileFormats.findIndex(el => el.id === id)
    state.fileFormats.splice(fileFormatToFindIndex, 1)
  },
  setFieldMapping: (state, payload) => {
    state.fieldMapping = payload
  },
  setFieldsMapping: (state, payload) => {
    if (state.fieldsMappingCurrentPage === 1) {
      state.fieldsMapping = payload
    } else {
      state.fieldsMapping.push(...payload)
    }
  },
  setFieldsMappingFilters: (state, payload) => { state.fieldsMappingFilters = payload },
  setFieldsMappingLastPage: (state, payload) => { state.fieldsMappingLastPage = payload },
  incrementFieldsMappingCurrentPage: (state, payload) => { state.fieldsMappingCurrentPage++ },
  addFieldMapping: (state, payload) => {
    const { id } = payload
    const fieldMappingToFindIndex = state.fieldsMapping.findIndex(el => el.id === id)
    if (fieldMappingToFindIndex !== -1) {
      state.fieldsMapping.splice(fieldMappingToFindIndex, 1, payload)
    } else {
      state.fieldsMapping.push(payload)
    }
  },
  deleteFieldMapping: (state, id) => {
    const fieldMappingToFindIndex = state.fieldsMapping.findIndex(el => el.id === id)
    state.fieldsMapping.splice(fieldMappingToFindIndex, 1)
  },

  setIsCallingExpenses: (state, payload) => { state.isCallingExpenses = payload },

  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }

}
